var _g, _rect, _rect2, _g2, _g3, _rect3, _rect4, _g4, _g5, _rect5, _rect6, _g6, _g7, _rect7, _rect8, _g8, _g9, _rect9, _rect10, _g10, _g11, _rect11, _rect12, _g12, _circle, _circle2, _circle3, _circle4, _g13, _circle5, _circle6, _g14, _g15, _circle7, _circle8, _g16, _g17, _circle9, _circle10, _g18, _g19, _circle11, _circle12, _g20, _g21, _circle13, _circle14, _g22, _g23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMolecule1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 328,
    viewBox: "0 0 330 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.4964,
    height: 2.28873,
    transform: "matrix(1 0 0 -1 125.879 35.4751)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.4964,
    height: 2.28873,
    transform: "matrix(1 0 0 -1 125.879 35.4751)",
    fill: "url(#paint0_radial_679_740)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74.3837,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(1 0 0 -1 114.434 37.7643)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 74.3837,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(1 0 0 -1 114.434 37.7643)",
    fill: "url(#paint1_radial_679_740)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.3837,
    height: 6.86618,
    transform: "matrix(1 0 0 -1 114.434 37.7643)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.2605,
    height: 2.28873,
    transform: "matrix(0.571511 0.820595 0.820595 -0.571511 231.422 59.1293)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68.2605,
    height: 2.28873,
    transform: "matrix(0.571511 0.820595 0.820595 -0.571511 231.422 59.1293)",
    fill: "url(#paint2_radial_679_740)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 98.5985,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(0.571511 0.820595 0.820595 -0.571511 220.875 47.9911)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 98.5985,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(0.571511 0.820595 0.820595 -0.571511 220.875 47.9911)",
    fill: "url(#paint3_radial_679_740)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.5985,
    height: 6.86618,
    transform: "matrix(0.571511 0.820595 0.820595 -0.571511 220.875 47.9911)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.5906,
    height: 2.28873,
    transform: "matrix(-0.397045 0.917799 0.917799 0.397045 269.047 172.128)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 59.5906,
    height: 2.28873,
    transform: "matrix(-0.397045 0.917799 0.917799 0.397045 269.047 172.128)",
    fill: "url(#paint4_radial_679_740)"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 86.0753,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(-0.397045 0.917799 0.917799 0.397045 272.203 159.067)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 86.0753,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(-0.397045 0.917799 0.917799 0.397045 272.203 159.067)",
    fill: "url(#paint5_radial_679_740)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.0753,
    height: 6.86618,
    transform: "matrix(-0.397045 0.917799 0.917799 0.397045 272.203 159.067)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.944,
    height: 2.28873,
    transform: "matrix(-0.99995 -0.00997728 -0.00997728 0.99995 178.516 265.1)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.944,
    height: 2.28873,
    transform: "matrix(-0.99995 -0.00997728 -0.00997728 0.99995 178.516 265.1)",
    fill: "url(#paint6_radial_679_740)"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 96.6968,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(-0.99995 -0.00997728 -0.00997728 0.99995 193.414 262.959)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 96.6968,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(-0.99995 -0.00997728 -0.00997728 0.99995 193.414 262.959)",
    fill: "url(#paint7_radial_679_740)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_b_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.6968,
    height: 6.86618,
    transform: "matrix(-0.99995 -0.00997728 -0.00997728 0.99995 193.414 262.959)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.944,
    height: 2.28873,
    transform: "matrix(-0.45759 -0.889163 -0.889163 0.45759 72.4102 222.567)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 66.944,
    height: 2.28873,
    transform: "matrix(-0.45759 -0.889163 -0.889163 0.45759 72.4102 222.567)",
    fill: "url(#paint8_radial_679_740)"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 96.6968,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(-0.45759 -0.889163 -0.889163 0.45759 81.25 234.745)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 96.6968,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(-0.45759 -0.889163 -0.889163 0.45759 81.25 234.745)",
    fill: "url(#paint9_radial_679_740)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_b_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.6968,
    height: 6.86618,
    transform: "matrix(-0.45759 -0.889163 -0.889163 0.45759 81.25 234.745)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.0982,
    height: 2.28873,
    transform: "matrix(0.529586 -0.848256 -0.848256 -0.529586 46.4688 120.388)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.0982,
    height: 2.28873,
    transform: "matrix(0.529586 -0.848256 -0.848256 -0.529586 46.4688 120.388)",
    fill: "url(#paint10_radial_679_740)"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 99.8085,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(0.529586 -0.848256 -0.848256 -0.529586 40.2773 134.626)",
    fill: "#D9D9D9",
    fillOpacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 99.8085,
    height: 6.86618,
    rx: 3.43309,
    transform: "matrix(0.529586 -0.848256 -0.848256 -0.529586 40.2773 134.626)",
    fill: "url(#paint11_radial_679_740)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_b_679_740)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.8085,
    height: 6.86618,
    transform: "matrix(0.529586 -0.848256 -0.848256 -0.529586 40.2773 134.626)",
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98.4146,
    cy: 36.6196,
    r: 22.8873,
    fill: "#AABFA7",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.4146,
    cy: 36.6196,
    r: 22.8873,
    fill: "url(#paint12_radial_679_740)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.8441,
    cy: 36.0469,
    r: 10.8715,
    fill: "#B2B2B2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.8441,
    cy: 36.0469,
    r: 10.8715,
    fill: "url(#paint13_radial_679_740)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_b_679_740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98.4146,
    cy: 36.6196,
    r: 22.8873,
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.14,
    cy: 34.3309,
    r: 34.3309,
    fill: "#AABFA7",
    fillOpacity: 0.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.14,
    cy: 34.3309,
    r: 34.3309,
    fill: "url(#paint14_radial_679_740)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_679_740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 215.711,
    cy: 34.9026,
    r: 13.1602,
    fill: "#FFBE7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 215.711,
    cy: 34.9026,
    r: 13.1602,
    fill: "url(#paint15_radial_679_740)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_b_679_740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 215.14,
    cy: 34.3309,
    r: 34.3309,
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.584,
    cy: 255.193,
    r: 40.0527,
    fill: "#AABFA7",
    fillOpacity: 0.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.584,
    cy: 255.193,
    r: 40.0527,
    fill: "url(#paint16_radial_679_740)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_679_740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.263,
    cy: 256.338,
    r: 18.3098,
    fill: "#45756E",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.263,
    cy: 256.338,
    r: 18.3098,
    fill: "url(#paint17_radial_679_740)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_b_679_740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88.584,
    cy: 255.193,
    r: 40.0527,
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.73,
    cy: 270.077,
    r: 57.2182,
    fill: "#FFBE7F",
    fillOpacity: 0.2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.73,
    cy: 270.077,
    r: 57.2182,
    fill: "url(#paint18_radial_679_740)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_679_740)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.442,
    cy: 267.216,
    rx: 24.0316,
    ry: 23.4595,
    fill: "#FFBE7F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.442,
    cy: 267.216,
    rx: 24.0316,
    ry: 23.4595,
    fill: "url(#paint19_radial_679_740)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_b_679_740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 227.73,
    cy: 270.077,
    r: 57.2182,
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.802,
    cy: 148.775,
    r: 45.7746,
    fill: "#AABFA7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.802,
    cy: 148.775,
    r: 45.7746,
    fill: "url(#paint20_radial_679_740)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_679_740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 287.235,
    cy: 149.918,
    r: 21.7429,
    fill: "#45756E",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.235,
    cy: 149.918,
    r: 21.7429,
    fill: "url(#paint21_radial_679_740)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_b_679_740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 283.802,
    cy: 148.775,
    r: 45.7746,
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.3309,
    cy: 141.901,
    r: 34.3309,
    fill: "#AABFA7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.3309,
    cy: 141.901,
    r: 34.3309,
    fill: "url(#paint22_radial_679_740)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_679_740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.7573,
    cy: 142.473,
    r: 16.5933,
    fill: "#FFBE7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.7573,
    cy: 142.473,
    r: 16.5933,
    fill: "url(#paint23_radial_679_740)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_b_679_740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.3309,
    cy: 141.901,
    r: 34.3309,
    fill: "#45756E",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_679_740",
    x: 121.879,
    y: 29.1863,
    width: 59.4961,
    height: 10.2888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_679_740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_679_740",
    x: 109.434,
    y: 25.8981,
    width: 84.3828,
    height: 16.8662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_679_740",
    x: 227.422,
    y: 53.8213,
    width: 48.8906,
    height: 65.3222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_679_740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_679_740",
    x: 215.875,
    y: 39.0671,
    width: 71.9844,
    height: 94.8334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_679_740",
    x: 241.387,
    y: 168.128,
    width: 33.7617,
    height: 63.601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_679_740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_679_740",
    x: 233.027,
    y: 154.067,
    width: 50.4766,
    height: 91.726,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_679_740",
    x: 107.551,
    y: 260.432,
    width: 74.9648,
    height: 10.9565,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_679_740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_b_679_740",
    x: 91.6523,
    y: 256.994,
    width: 106.762,
    height: 17.8306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_679_740",
    x: 35.7422,
    y: 159.043,
    width: 40.668,
    height: 68.5714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_679_740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_b_679_740",
    x: 25.8984,
    y: 143.766,
    width: 60.3516,
    height: 99.1212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_679_740",
    x: 40.5273,
    y: 56.5633,
    width: 46.5352,
    height: 67.825,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_679_740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_b_679_740",
    x: 29.4531,
    y: 41.3262,
    width: 68.6797,
    height: 98.2994,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_b_679_740",
    x: 70.5273,
    y: 8.73236,
    width: 55.7734,
    height: 55.7746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_679_740",
    x: 192.551,
    y: 11.7424,
    width: 46.3203,
    height: 46.3204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_679_740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_b_679_740",
    x: 175.809,
    y: -5,
    width: 78.6602,
    height: 78.6619,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_679_740",
    x: 60.9531,
    y: 228.028,
    width: 56.6211,
    height: 56.6196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_679_740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_b_679_740",
    x: 43.5312,
    y: 210.14,
    width: 90.1055,
    height: 90.1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_679_740",
    x: 191.41,
    y: 233.756,
    width: 68.0625,
    height: 66.9189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_679_740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_b_679_740",
    x: 165.512,
    y: 207.859,
    width: 124.438,
    height: 124.436,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_679_740",
    x: 255.492,
    y: 118.176,
    width: 63.4844,
    height: 63.4858,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_679_740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_b_679_740",
    x: 233.027,
    y: 98,
    width: 101.551,
    height: 101.549,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_679_740",
    x: 7.16406,
    y: 115.88,
    width: 53.1875,
    height: 53.1866,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_679_740"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_b_679_740",
    x: -5,
    y: 102.57,
    width: 78.6602,
    height: 78.6619,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_679_740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_679_740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.49902 -0.393614) rotate(4.61585) scale(34.1397 3.0539)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.031 2.06288) rotate(5.12335) scale(42.2306 7.74628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.28917 -0.393614) rotate(3.48549) scale(45.1903 3.05817)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8773 2.06288) rotate(3.86955) scale(55.8821 7.75963)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.36336 -0.393614) rotate(3.99107) scale(39.4734 3.05641)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3366 2.06288) rotate(4.43043) scale(48.8191 7.75412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.14858 -0.393614) rotate(3.55387) scale(44.322 3.05795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3397 2.06288) rotate(3.94541) scale(54.8093 7.75893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.14858 -0.393614) rotate(3.55387) scale(44.322 3.05795)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.3397 2.06288) rotate(3.94541) scale(54.8093 7.75893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.37862 -0.393614) rotate(3.44334) scale(45.7429 3.05831)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.2195 2.06288) rotate(3.82278) scale(56.5648 7.76005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.4695 27.4849) rotate(44.1659) scale(36.0844 37.1927)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.2945 21.4361) rotate(61.1678) scale(29.7935 14.0365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.222 20.6288) rotate(44.1659) scale(54.1266 55.789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.361 17.2158) rotate(61.1678) scale(36.0658 16.9915)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.18 239.207) rotate(44.1659) scale(63.1477 65.0871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.8635 231.73) rotate(61.1678) scale(50.1785 23.6404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.867 247.24) rotate(44.1659) scale(90.211 92.9816)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(206.543 235.687) rotate(60.5808) scale(64.6593 30.8514)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(263.912 130.505) rotate(44.1659) scale(72.1688 74.3853)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(270.136 120.697) rotate(61.1678) scale(59.587 28.073)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4132 128.199) rotate(44.1659) scale(54.1266 55.789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_679_740",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7079 120.172) rotate(61.1678) scale(45.4743 21.4241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188719,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388357,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623241,
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829876,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolecule1);
export default __webpack_public_path__ + "static/media/molecule-1.42a6b79d2aa2bea0fbd398c0176ee6cc.svg";
export { ForwardRef as ReactComponent };